import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/stores/authStore";
import type { Role } from "@/lib/supabase";
import { ReactNode } from "react";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullScreenSpinner />;
  if (!session) return <Navigate to="/login" state={{ from: location }} replace />;
  return <>{children}</>;
}

export function RequireRole({ roles, children }: { roles: Role[]; children: ReactNode }) {
  const { session, role, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullScreenSpinner />;
  if (!session) return <Navigate to="/login" state={{ from: location }} replace />;
  if (!roles.includes(role)) return <Navigate to="/" replace />;
  return <>{children}</>;
}

function FullScreenSpinner() {
  return (
    <div
      style={{ height: "calc(100% - var(--tastatur, 0px))" }}
      className="grid place-items-center bg-hof-50"
    >
      <div className="h-12 w-12 rounded-full border-4 border-wiese-200 border-t-wiese-600 animate-spin" />
    </div>
  );
}
